const timePeriod = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  YEAR: 'year'
};
const timePeriodPlural = {
  DAY: 'days',
  WEEK: 'weeks',
  MONTH: 'months',
  YEAR: 'years'
};
export const getTimeText = _ref => {
  let {
    unit,
    count
  } = _ref;
  if (count === 1) {
    return timePeriod[unit];
  }
  return `${count} ${timePeriodPlural[unit]}`;
};
export const getPriceText = _ref2 => {
  let {
    duration,
    formattedPrice,
    price
  } = _ref2;
  const {
    isRecurring,
    cycleLength,
    timeUnit
  } = duration;
  if (price.value === '0') {
    return 'Free';
  }
  if (!isRecurring) {
    return formattedPrice;
  }
  return `${formattedPrice} per ${getTimeText({
    unit: timeUnit,
    count: cycleLength
  })}`;
};
export const getFullDurationText = props => {
  const {
    cycleCount,
    timeUnit,
    cycleLength
  } = props;
  const isUnlimited = cycleCount === 0;
  if (isUnlimited) {
    return 'Valid until canceled';
  }
  const unit = timeUnit;
  const fullLength = cycleLength * cycleCount;
  const isEqualToOne = fullLength === 1;
  const duration = getTimeText({
    unit,
    count: fullLength
  });
  const durationText = isEqualToOne ? `a ${duration}` : duration;
  return `Valid for ${durationText}`;
};
//# sourceMappingURL=utils.js.map